import AccordionModule from "@/components/site-builder/modules/AccordionModule";
import ButtonGroupModule from "@/components/site-builder/modules/ButtonGroupModule";
import ColumnTextModule from "@/components/site-builder/modules/ColumnTextModule";
import CustomFormModule from "@/components/site-builder/modules/CustomFormModule";
import DropColumnModule from "@/components/site-builder/modules/DropColumnModule";
import ExhibitorListModule from "@/components/site-builder/modules/ExhibitorListModule";
import FileDownloadModule from "@/components/site-builder/modules/FileDownloadModule";
import HeroCarouselModule from "@/components/site-builder/modules/HeroCarouselModule";
import HeroModule from "@/components/site-builder/modules/HeroModule";
import HtmlBlockModule from "@/components/site-builder/modules/HtmlBlockModule";
import IframeModule from "@/components/site-builder/modules/IframeModule";
import ImageGalleryModule from "@/components/site-builder/modules/ImageGalleryModule";
import ImageModule from "@/components/site-builder/modules/ImageModule";
import SpeakersModule from "@/components/site-builder/modules/SpeakersModule";
import SponsorCategoryModule from "@/components/site-builder/modules/SponsorCategoryModule";
import StatisticsModule from "@/components/site-builder/modules/StatisticsModule";
import TestimonialModule from "@/components/site-builder/modules/TestimonialModule";
import TextContentModule from "@/components/site-builder/modules/TextContentModule";
import VideoGalleryModule from "@/components/site-builder/modules/VideoGalleryModule";
import VideoModule from "@/components/site-builder/modules/VideoModule";
import { SiteBuilderModuleType } from "@/constants/site-builder";
import type { AccordionModuleType } from "@/components/site-builder/modules/AccordionModule/types";
import type { ButtonGroupModuleType } from "@/components/site-builder/modules/ButtonGroupModule/types";
import type { ColumnTextModuleType } from "@/components/site-builder/modules/ColumnTextModule/types";
import type { CustomFormModuleType } from "@/components/site-builder/modules/CustomFormModule/types";
import type { DropColumnModuleType } from "@/components/site-builder/modules/DropColumnModule/types";
import type { ExhibitorListModuleType } from "@/components/site-builder/modules/ExhibitorListModule/types";
import type { FileDownloadModuleType } from "@/components/site-builder/modules/FileDownloadModule/types";
import type { HeroCarouselModuleType } from "@/components/site-builder/modules/HeroCarouselModule/types";
import type { HeroModuleType } from "@/components/site-builder/modules/HeroModule/types";
import type { HtmlBlockModuleType } from "@/components/site-builder/modules/HtmlBlockModule/types";
import type { IframeModuleType } from "@/components/site-builder/modules/IframeModule/types";
import type { ImageGalleryModuleType } from "@/components/site-builder/modules/ImageGalleryModule/types";
import type { ImageModuleType } from "@/components/site-builder/modules/ImageModule/types";
import type { SpeakersModuleType } from "@/components/site-builder/modules/SpeakersModule/types";
import type { SponsorCategoryModuleType } from "@/components/site-builder/modules/SponsorCategoryModule/types";
import type { StatisticsModuleType } from "@/components/site-builder/modules/StatisticsModule/types";
import type { TestimonialModuleType } from "@/components/site-builder/modules/TestimonialModule/types";
import type { TextContentModuleType } from "@/components/site-builder/modules/TextContentModule/types";
import type { VideoGalleryModuleType } from "@/components/site-builder/modules/VideoGalleryModule/types";
import type { VideoModuleType } from "@/components/site-builder/modules/VideoModule/types";
import type { BaseSiteBuilderModule } from "@/types/site-builder";

export interface ModuleMapperProps {
  module: BaseSiteBuilderModule;
}

export default function ModuleMapper({ module }: ModuleMapperProps) {
  switch (module["@type"]) {
    case SiteBuilderModuleType.Accordion:
      return <AccordionModule module={module as AccordionModuleType} />;

    case SiteBuilderModuleType.ButtonGroup:
      return <ButtonGroupModule module={module as ButtonGroupModuleType} />;

    case SiteBuilderModuleType.ColumnText:
      return <ColumnTextModule module={module as ColumnTextModuleType} />;

    case SiteBuilderModuleType.CustomForm:
      return <CustomFormModule module={module as CustomFormModuleType} />;

    case SiteBuilderModuleType.DropColumn:
      return <DropColumnModule module={module as DropColumnModuleType} />;

    case SiteBuilderModuleType.ExhibitorList:
      return <ExhibitorListModule module={module as ExhibitorListModuleType} />;

    case SiteBuilderModuleType.FileDownload:
      return <FileDownloadModule module={module as FileDownloadModuleType} />;

    case SiteBuilderModuleType.Hero:
      return <HeroModule module={module as HeroModuleType} />;

    case SiteBuilderModuleType.HeroCarousel:
      return <HeroCarouselModule module={module as HeroCarouselModuleType} />;

    case SiteBuilderModuleType.HtmlBlock:
      return <HtmlBlockModule module={module as HtmlBlockModuleType} />;

    case SiteBuilderModuleType.Iframe:
      return <IframeModule module={module as IframeModuleType} />;

    case SiteBuilderModuleType.Image:
      return <ImageModule module={module as ImageModuleType} />;

    case SiteBuilderModuleType.ImageGallery:
      return <ImageGalleryModule module={module as ImageGalleryModuleType} />;

    case SiteBuilderModuleType.Speakers:
      return <SpeakersModule module={module as SpeakersModuleType} />;

    case SiteBuilderModuleType.SponsorCategory:
      return (
        <SponsorCategoryModule module={module as SponsorCategoryModuleType} />
      );

    case SiteBuilderModuleType.Statistics:
      return <StatisticsModule module={module as StatisticsModuleType} />;

    case SiteBuilderModuleType.Testimonial:
      return <TestimonialModule module={module as TestimonialModuleType} />;

    case SiteBuilderModuleType.TextContent:
      return <TextContentModule module={module as TextContentModuleType} />;

    case SiteBuilderModuleType.Video:
      return <VideoModule module={module as VideoModuleType} />;

    case SiteBuilderModuleType.VideoGallery:
      return <VideoGalleryModule module={module as VideoGalleryModuleType} />;

    default:
      return null;
  }
}
